// UI效果模块
export class UIEffects {
    constructor() {
        this.init();
    }

    init() {
        document.addEventListener('DOMContentLoaded', () => {
            this.addRandomIconColors();
        });
    }

    addRandomIconColors() {
        const colors = [
            '#0072b5', '#00a6d6', '#2c5282', '#2b6cb0', '#3182ce',
            '#4299e1', '#63b3ed', '#4c51bf', '#6b46c1', '#805ad5'
        ];

        document.querySelectorAll('.link-icon').forEach(icon => {
            icon.style.color = colors[Math.floor(Math.random() * colors.length)];
        });
    }
}

// 初始化UI效果
new UIEffects();
